import { useQuery } from "convex/react";

import { IdentityReconciliationAlert } from "../features/circle";
import { identityReconciliationAlertQuery } from "./identityReconciliation";

/** Mounted only behind the server-derived plan-management affordance. */
export function IdentityReconciliationRoute({ circleId }: { readonly circleId: string }) {
  const alert = useQuery(identityReconciliationAlertQuery, { circleId });
  if (alert === undefined || alert === null) return null;
  return <IdentityReconciliationAlert alert={alert} />;
}
